import React from 'react';
import Background from '../components/Background';
import Projects from '../components/Projects';

const ProjectsPage = () => {
  return (
    <>
      <Background />
      <div className="page">
        <Projects />
      </div>
    </>
  );
};

export default ProjectsPage;
